export default IconCurrencyTugrik => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-currency-tugrik" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M7 6h10" />
  <path d="M12 6v13" />
  <path d="M8 17l8 -3" />
  <path d="M16 10l-8 3" />
</svg>`;